import 'arrive';

document.arrive('.filter-publications', { existing: true }, function () {
    const categoriesContainer = document.querySelector('.filter-publications__categories');
    const activeCategory = document.querySelector('.filter-publications__category.active');

    if (!categoriesContainer || !activeCategory) return;

    // Solo su mobile o viewport <= 1000px
    if (window.innerWidth <= 1000) {
        const containerRect = categoriesContainer.getBoundingClientRect();
        const activeRect = activeCategory.getBoundingClientRect();

        // gap impostato nel CSS
        const relativeLeft = activeRect.left - containerRect.left;
        const currentScroll = categoriesContainer.scrollLeft;

        // Compensa il gap per evitare che resti troppo attaccato
        const scrollTarget = relativeLeft + currentScroll;

        categoriesContainer.scrollTo({
            left: scrollTarget,
            behavior: 'smooth'
        });
    }
});
